
import React from 'react';
import { Dialog, DialogActions, DialogContent, Typography, DialogTitle,Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


const BrandLimitsInfoDialog = ({ open, onClose, onGoToResellerSettings }) => {
  const { t: translate } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1.5}>
          <InfoOutlinedIcon color="info" />
          {translate('common.why_set_limits') || 'Why set limits per brand?'}
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography paragraph>
          {translate('brand.limits_purpose_1') ||
            'In reseller mode you can create multiple brands (sub-accounts / customers) under your agency / reseller account.'}
        </Typography>

        <Typography paragraph>
          {translate('brand.limits_purpose_2') || 'Setting limits helps you:'}
        </Typography>

        <ul style={{ paddingLeft: '1.5rem', margin: '8px 0 16px' }}>
          <li>{translate('brand.limits_reason_users') || 'Control how many users each customer can invite'}</li>
          <li>
            {translate('brand.limits_reason_accounts') || 'Restrict number of connected social accounts per brand'}
          </li>
          <li>
            {translate('brand.limits_reason_ai') ||
              'Manage AI usage (text generation & image generation tokens) and prevent unexpected costs'}
          </li>
        </ul>

        <Typography paragraph sx={{ fontWeight: 500, mt: 3 }}>
          {translate('brand.dont_want_limits') || 'Don’t want to set any limits?'}
        </Typography>

        <Typography>
          {translate('brand.disable_reseller_hint') ||
            'You can disable reseller mode at any time. After disabling, you will only manage one main brand without sub-limits.'}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button color="error" variant="outlined" onClick={onClose}>
          {translate('common.close')}
        </Button>
        <Button variant="outlined" color="warning" onClick={onGoToResellerSettings}>
          {translate('common.manage_reseller_mode') || 'Go to reseller settings'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BrandLimitsInfoDialog;